import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@thinkalpha/ui-core/utils';
import type { KeysWithoutReturnObjects } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useJsonFormExternalConfig } from 'src/components/JsonForm/JsonFormExternalConfigContext';
import { Tooltip } from 'src/components/ui';

export const Label = ({
    label,
    className,
    htmlFor,
}: {
    label: string;
    required?: boolean;
    className?: string;
    htmlFor?: string;
}) => {
    const { t } = useTranslation();
    const config = useJsonFormExternalConfig();
    return (
        <label htmlFor={htmlFor} className={cn('block cursor-pointer text-sm text-yellow-300 select-none', className)}>
            {t(`${config.translationPrefix}::labels::${label}` as KeysWithoutReturnObjects['json'], label)}
        </label>
    );
};

export const Description = ({ description }: { description?: string }) => {
    const { t } = useTranslation();
    const config = useJsonFormExternalConfig();
    return (
        description && (
            <Tooltip
                asChild
                content={t(
                    `${config.translationPrefix}::labels::${description}` as KeysWithoutReturnObjects['json'],
                    description,
                )}
                delayDuration={0}
                className="max-w-96 text-sm"
            >
                <FontAwesomeIcon icon={faCircleInfo} className="h-2.5 w-2.5 shrink-0 text-gray-300 opacity-50" />
            </Tooltip>
        )
    );
};

export const Errors = ({ errors }: { errors?: string }) => {
    const { t } = useTranslation();
    const config = useJsonFormExternalConfig();
    return (
        errors && <>{t(`${config.translationPrefix}::errors::${errors}` as KeysWithoutReturnObjects['json'], errors)}</>
    );
};
